"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/ReviewBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _useRecipientsView = require('web/screens/Broadcast/Recipients/useRecipientsView');
var _format = require('web/screens/Broadcast/format');






/* Replaces the progress bar while the table shows only the recipients the
 * launch gate would refuse. With more than a page, it says which are shown. */
const ReviewBar = ({ blocked, onShowAll }) => {
  const { isLoading, total, page, rows } = blocked
  const first = page * _useRecipientsView.PAGE_SIZE + 1
  return (
    _react2.default.createElement('div', { className: "campaign--table--review-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      , _react2.default.createElement('span', { className: "campaign--table--review-chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
        ,  isLoading
          ? 'Checking recipients…'
          : _react2.default.createElement(_react2.default.Fragment, null, "Can't be sent this message: "
                   ,  _format.pluralize.call(void 0, total, 'recipient', 'recipients') 
            )
        
      )
      ,  !isLoading && total > _useRecipientsView.PAGE_SIZE && rows.length > 0 && (
        _react2.default.createElement('span', { className: "campaign--table--review-range", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, "Showing "
           ,  _format.formatCount.call(void 0, first) , "–",  _format.formatCount.call(void 0, first + rows.length - 1) , " of "  ,  _format.formatCount.call(void 0, total) 
        )
      )
      , _react2.default.createElement('span', { className: "campaign--table--review-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "Select recipients to remove them, or fix the message."

      )
      ,  onShowAll && (
        _react2.default.createElement('button', { type: "button", className: "campaign--table--review-clear", onClick: onShowAll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "Show all recipients"

        )
      )
    )
  )
}

exports. default = ReviewBar
